var path = 'msi/paymetric/paymetric.html';
var html = "<iframe ng-src=\"{{$ctrl.src}}\" id=\"og-paymetric-iframe\" name=\"paymetric-iframe\"></iframe>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;